"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Do I need a prescription to start physical therapy?",
  answer: "No. New Jersey is a direct-access state, which means you can begin your recovery or performance training immediately without a doctor's referral. This allows us to start your care the moment you need it, saving you time and unnecessary co-pays."
}, {
  question: "Do you accept insurance?",
  answer: "Physically Sound is an out-of-network provider. By working outside the constraints of insurance companies, we can provide 60-minute, 1-on-1 sessions focused entirely on your goals. We provide detailed receipts (superbills) that you can submit for potential reimbursement."
}, {
  question: "What areas of Monmouth County do you serve?",
  answer: "We bring elite care directly to your door in Rumson, Red Bank, Little Silver, Middletown, and surrounding communities. Whether it's your home, office, or private gym, we provide a premium mobile concierge experience."
}, {
  question: "What makes the concierge model different from a clinic?",
  answer: "In a traditional clinic, therapists often see multiple patients at once. With us, you get 100% of Dr. Dave's attention for the full hour. There are no aides, no double-booking, and you receive 24/7 access to your custom program via our integrated rehab app."
}, {
  question: "Can I book a session if I am not currently injured?",
  answer: "Absolutely. We specialize in performance coaching and injury prevention. Many clients start with our 30-Minute Movement Check-Up or a TPI Golf Performance screen to identify physical limitations and optimize their athletic performance."
}];
export default function EverythingYouNeedToKnow() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="82252" id="common-questions" className="py-20 md:py-32 px-4 md:px-8 bg-background text-foreground">
      <div className="max-w-3xl mx-auto">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary tracking-tight mb-4">
            Common Questions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to know about our elite concierge physical therapy and performance coaching services.
          </p>
        </div>

        <div ref={listRef} className={`transition-all duration-700 delay-200 ease-out ${isListVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border last:border-b last:border-border rounded-2xl bg-card overflow-hidden shadow-sm data-[state=open]:shadow-lg transition-all duration-200">
                <AccordionTrigger className="text-base md:text-lg font-bold text-primary hover:no-underline hover:text-secondary py-5 px-6 [&>svg]:text-chart-3 [&>svg]:size-6 [&>svg]:stroke-[2]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-base text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}